class NumServices {
  constructor(view, reprintNumServicesEl, podcastNumServicesEl, recordedAudioContainerEl, serviceTracksSelect, practiceTracksSelect, recordedTypeContainerEl) {
    this.view = view;

    this.reprintNumServicesEl = reprintNumServicesEl;
    this.podcastNumServicesEl = podcastNumServicesEl;
    this.recordedAudioContainerEl = recordedAudioContainerEl;

    this.serviceTracksSelect = serviceTracksSelect;
    this.practiceTracksSelect = practiceTracksSelect;
    this.recordedTypeContainerEl = recordedTypeContainerEl;

    this.hasRecording = practiceTracksSelect.length || serviceTracksSelect.length;

    this.configureElements();
    this.bindElements();
    this.toggleServicesBasedOnLicenseAndSongType();
  }

  configureElements() {
    this.reprintNumServicesEl.select2nonUnique({
      placeholder: 'Number of services',
      minimumResultsForSearch: Infinity
    });

    this.podcastNumServicesEl.select2nonUnique({
      placeholder: 'Number of services',
      minimumResultsForSearch: Infinity
    });

    this.serviceTracksSelect.select2nonUnique({
      placeholder: __('Used in Service'),
      minimumResultsForSearch: Infinity
    });

    this.practiceTracksSelect.select2nonUnique({
      placeholder: __('Used in Practice'),
      minimumResultsForSearch: Infinity
    });
  }

  bindElements() {
    const view = this.view;

    view.bind(this.podcastNumServicesEl, 'change.select2', (e) => {
      this.changePodcastNumServices(e);
    }).change();

    view.bind(this.reprintNumServicesEl, 'change.select2', (e) => {
      this.changeReprintNumServices(e);
    }).change();

    view.bind(this.serviceTracksSelect, 'change.select2', (e) => {
      this.changeServiceTracks(e);
    }).change();

    view.bind(this.practiceTracksSelect, 'change.select2', (e) => {
      this.changePracticeTracks(e);
    }).change();
  }

  onLicenseSelect(e) {
    this.toggleServicesBasedOnLicenseAndSongType();
  }

  changeReprintNumServices() {
    this.ensureNotZeroNumServices(this.reprintNumServicesEl);
  }

  changePodcastNumServices() {
    this.ensureNotZeroNumServices(this.podcastNumServicesEl);
  }

  changeServiceTracks() {
    this.ensureNotZeroNumServices(this.serviceTracksSelect);
  }

  changePracticeTracks() {
    this.ensureNotZeroNumServices(this.practiceTracksSelect);
  }

  ensureNotZeroNumServices(currentEl) {
    if (this.view.fillingData) {
      return;
    }

    const fieldsToCheck = [
      this.reprintNumServicesEl,
      this.podcastNumServicesEl,
    ];

    if (this.hasRecording) {
      fieldsToCheck.push(this.serviceTracksSelect);
      fieldsToCheck.push(this.practiceTracksSelect);
    }

    const sumArr = fieldsToCheck.map((selectEl) => {
      return parseInt(selectEl.val());
    });

    let sum = sumArr.reduce((acc, val) => acc + val, 0);

    if (sum <= 0) {
      currentEl.val(1).change();
      sum = 1;
    }

    if (!this.view.submitAndStayEl || !this.view.submitAndViewEl) return;

    if (sum <= 0) {
      this.view.submitAndStayEl.prop('disabled', true);
      this.view.submitAndViewEl.prop('disabled', true);
    } else {
      this.view.submitAndStayEl.prop('disabled', false);
      this.view.submitAndViewEl.prop('disabled', false);
    }
  }

  static toggleServicesElements(reprint, podcast, recording, commercial, nonCommercial, reprintServicesEl, podcastServicesEl, recordedAudioContainerEl, serviceTracksSelect, practiceTracksSelect, recordedTypeContainerEl, commercialEl, nonCommercialEl) {
    const reprintAndPodcast = reprint && podcast;
    const hideCommercial = !commercial || !nonCommercial;
    const hideRecordedAudio = !commercial && !nonCommercial;
    const reprintServices = reprintServicesEl.parent().parent().find('.reprint-services');
    const podcastServices = podcastServicesEl.parent().parent().find('.podcast-services');
    const reprintServicesEmptyOption = reprintServicesEl.find('option[value="0"]');
    const podcastServicesEmptyOption = podcastServicesEl.find('option[value="0"]');

    reprintServices.removeClass('reprint-podcast reprint podcast');
    podcastServices.removeClass('reprint-podcast reprint podcast');

    reprintServicesEmptyOption.prop('disabled', reprint && !reprintAndPodcast && !recording);
    podcastServicesEmptyOption.prop('disabled', podcast && !reprintAndPodcast && !recording);

    if (reprint && podcast) {
      reprintServices.addClass('reprint-podcast');
      podcastServices.addClass('reprint-podcast');
    } else if (reprint) {
      podcastServicesEl.val(0).change();
      reprintServices.addClass('reprint');
      podcastServices.addClass('reprint');
    } else {
      reprintServicesEl.val(0).change();
      reprintServices.addClass('podcast');
      podcastServices.addClass('podcast');
    }

    if (recordedAudioContainerEl && serviceTracksSelect && practiceTracksSelect) {
      if (recording && !hideRecordedAudio) {
        recordedAudioContainerEl.fadeIn(200);
      } else {
        recordedAudioContainerEl.hide();
        serviceTracksSelect.val(0).change();
        practiceTracksSelect.val(0).change();
      }
    }

    if (recordedTypeContainerEl) {
      if (!hideCommercial) {
        recordedTypeContainerEl.fadeIn(200);
      } else {
        recordedTypeContainerEl.hide();
        if (commercial) {
          recordedTypeContainerEl.find('input[name=is_commercial][id=1]').prop('checked', true);
        }

        if (nonCommercial) {
          recordedTypeContainerEl.find('input[name=is_commercial][id=0]').prop('checked', true);
        }
      }
    }
  }

  toggleServices(reprint, podcast, recording, commercial, nonCommercial) {
    this.constructor.toggleServicesElements(
      reprint,
      podcast,
      recording,
      commercial,
      nonCommercial,
      this.reprintNumServicesEl,
      this.podcastNumServicesEl,
      this.recordedAudioContainerEl,
      this.serviceTracksSelect,
      this.practiceTracksSelect,
      this.recordedTypeContainerEl
    );
  }

  toggleServicesBasedOnLicenseAndSongType() {
    let podcast;
    let reprint;
    let recording;
    let commercial = false;
    let nonCommercial = false;

    const licenseTypeData = this.getLicenseReprintAndPodcast();
    const buttonData = this.getButtonLicenseAndPodcast();
    const recordingType = this.getButtonCommercialAndNonCommercial();

    if (licenseTypeData) {
      podcast = licenseTypeData.podcast;
      recording = licenseTypeData.recording;
      reprint = licenseTypeData.reprint;

    }

    if (buttonData) {
      if (typeof podcast !== 'undefined') {
        podcast = podcast && buttonData.podcast;
      } else {
        podcast = buttonData.podcast;
      }

      if (typeof reprint !== 'undefined') {
        reprint = reprint && buttonData.reprint;
      } else {
        reprint = buttonData.reprint;
      }
    }

    if (recordingType) {
      commercial = recordingType.commercial;
      nonCommercial = recordingType.nonCommercial;
    }

    this.toggleServices(reprint, podcast, recording, commercial, nonCommercial);
  }

  getLicenseReprintAndPodcast() {
    let reprint;
    let podcast;
    let recording;

    if (typeof this.view.licenseTypeSelect !== 'undefined') {
      const selectedOption = this.view.licenseTypeSelect.find('option:selected');

      reprint = selectedOption.data('is-reprint');
      podcast = selectedOption.data('is-podcast');
      recording = selectedOption.data('is-recording');

      return { reprint, podcast, recording };
    }

    return false;
  }

  getButtonLicenseAndPodcast() {
    let reprint;
    let podcast;

    if (
      typeof this.view.buttonData !== 'undefined'
      && ('reprint' in this.view.buttonData)
      && ('podcast' in this.view.buttonData)
    ) {
      reprint = this.view.buttonData.reprint;
      podcast = this.view.buttonData.podcast;

      return { reprint, podcast };
    }

    return false;
  }

  getButtonCommercialAndNonCommercial() {
    let commercial;
    let nonCommercial;

    if (
      typeof this.view.buttonData !== 'undefined'
      && ('commercial' in this.view.buttonData)
      && ('nonCommercial' in this.view.buttonData)
    ) {
      commercial = this.view.buttonData.commercial;
      nonCommercial = this.view.buttonData.nonCommercial;

      return { commercial, nonCommercial };
    }

    return false;
  }

  static updateNumServicesLabels(currentBtn, reprintNumServices, podcastNumServices, numServiceTracks, numPracticeTracks, isCommercial) {
    const currentRow = currentBtn.parent().parent();
    const podcastReprintLabel = currentRow.find('.reprint_podcast_services_label');
    const infoPodcastServices = currentRow.find('.info_podcast_services');
    const infoReprintServices = currentRow.find('.info_reprint_services');
    const infoServiceTracks = currentRow.find('.info_service_tracks');
    const infoPracticeTracks = currentRow.find('.info_practice_tracks');
    const infoCommercial = currentRow.find('.info_commercial');
    const servicesLabel = currentRow.find('.services_label');
    const tracksLabel = currentRow.find('.tracks_label');

    if (reprintNumServices === 0 && podcastNumServices === 0) {
      podcastReprintLabel.hide();
    } else {
      podcastReprintLabel.show();
    }

    if (reprintNumServices > 0) {
      infoReprintServices.parent().show();
      infoReprintServices.html(reprintNumServices);
    } else {
      infoReprintServices.parent().hide();
    }

    if (podcastNumServices > 0) {
      infoPodcastServices.parent().show();
      infoPodcastServices.html(podcastNumServices);
    } else {
      infoPodcastServices.parent().hide();
    }

    if (numServiceTracks > 0) {
      infoServiceTracks.parent().show();
      infoServiceTracks.html(numServiceTracks);
    } else {
      infoServiceTracks.parent().hide();
    }

    if (numPracticeTracks > 0) {
      infoPracticeTracks.parent().show();
      infoPracticeTracks.html(numPracticeTracks);
    } else {
      infoPracticeTracks.parent().hide();
    }

    if (numServiceTracks > 0 || numPracticeTracks > 0) {
      tracksLabel.show();
      infoCommercial.show();
      infoCommercial.find('.info_commercial_type').html(isCommercial ? __('Commercial') : __('Non-commercial'));
    } else {
      infoCommercial.hide();
      tracksLabel.hide();
    }

    servicesLabel.html(reprintNumServices > 1 || podcastNumServices > 1 || (reprintNumServices > 0 && podcastNumServices > 0) ? __(' services') : __(' service'));
    tracksLabel.html(numServiceTracks > 1 || numPracticeTracks > 1 || (numServiceTracks > 0 && numPracticeTracks > 0)  ? ` ${__('tracks')}` : ` ${__('track')}`);

    if (isCommercial !== null) {
      isCommercial = isCommercial ? 1 : 0;
    }

    currentBtn.data('reprint-num-services', reprintNumServices);
    currentBtn.data('podcast-num-services', podcastNumServices);
    currentBtn.data('num-service-tracks', numServiceTracks);
    currentBtn.data('num-practice-tracks', numPracticeTracks);
    currentBtn.data('is-commercial', isCommercial);
  }
}

module.exports = NumServices;
